import { render, staticRenderFns } from "./PosReports.vue?vue&type=template&id=15a4d8dc&scoped=true"
import script from "./PosReports.vue?vue&type=script&lang=js"
export * from "./PosReports.vue?vue&type=script&lang=js"
import style0 from "./PosReports.vue?vue&type=style&index=0&id=15a4d8dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a4d8dc",
  null
  
)

export default component.exports